// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"f45387d2","44":"c2c157d8","219":"6f80e6a3","257":"b67ac563","328":"ee245c4b","387":"03e94e1e","407":"7192f256","453":"117b0875","587":"8d3ddc7b","892":"e41e2570","904":"f427daff","954":"d097dab3"}[chunkId] + ".chunk.js";
};